export default "__VITE_ASSET__31231c6d__"